/*
 * @Author: caiqin.xie
 * @since: 2023-08-14 19:23:26
 * @lastTime: 2023-09-12 11:20:48
 * @LastEditors: caiqin.xie
 * @message: 全屏播放视频组件
 */
import React, {useEffect, useState} from "react";
import { IconClose } from "@arco-design/web-react/icon";
import styles from "./index.module.scss";

interface IProps {
  words: Record<string, string>;
  videoUrl: string;
  setIsShowVideo: (isShowVideo: boolean) => void;
}

const VideoDialog = (props:IProps) => {
  const {words, videoUrl, setIsShowVideo} = props
  console.log(videoUrl)
  return (
    <div className={styles['video-marker']}>
      <div className={styles['close-btn']} onClick={() => setIsShowVideo(false)}>
        <IconClose className={styles['cor-white']} />
      </div>
      <div className={styles['video-container']}>
        <video controls autoPlay muted>
          <source src={videoUrl} type="video/mp4" />
          {words?.common_video_not_supported}
        </video>
      </div>
    </div>
  )
}
export default VideoDialog
